import { IScore } from './../../../resource/score/score.types';
import { call, put, select } from 'redux-saga/effects';
// import * as meetingsSimpleActions from '../meetings-simple/meetings-simple.actions';

import * as actions from './meetings.actions';
import * as agendaItemsAction from '../agenda-items/agenda-items.actions';
import * as meetingResourceService from '../../../resource/meeting/meeting.saga-service';
import * as sessionResourceService from '../../../resource/session/session.saga-service';
import * as dialogService from '../../../dialog/dialog.saga-services';
import * as scoreApi from '../../../api/request-config/score.api';

import {
  IMeetingSearchParams,
  IMeeting,
  MeetingType,
  IMeetingResponse,
  IMeetingNewCreateForm,
} from '../../../resource/meeting/meeting.types';
import { meetingsPageSelectors } from './meetings.selectors';
import { IReducedMeetings } from './meetings.types';
import { meetingSelectors } from '../../../resource/meeting/meeting.selectors';
import { IUser } from '../../../resource/user/user.types';
import { ISession } from '../../../resource/session/session.types';
import { selectWithParams } from '../../../../utils/selector.utils';
import { storeAgendaItems } from '../agenda-items/agenda-items.saga-services';
import { formSelectors } from '../users/user-form/user-form.selectors';
import { sessionSelectors } from '../../../resource/session/session.selectors';
import { saveCropCounter, saveFormAvatar } from '../users/user-form/user-form.actions';
import { push } from 'connected-react-router';
// import { moveToNextAgenda } from '../agenda-items/agenda-items.actions';
import slugify from 'react-slugify';
import { meetingSimpleSelectors } from '../../../resource/meeting-simple/meeting-simple.selectors';
import { IKpiRowScoreboard } from '../../../resource/kpi-row-scoreboard/kpi-row-scoreboard.types';
import { storeSessionIds } from '../kpi/kpi.actions';
import { apiRequest } from '../../../api/api.saga-services';

// import * as apiService from '../../api/api.saga-services';

export function* reduceAndStoreMeetings(meetings: IMeeting[]) {
  if (!meetings) {
    return;
  }
  yield put(
    actions.storeReducedMeetings(
      meetings.reduce((prev, curr) => {
        if (!prev[curr.type]) {
          prev[curr.type] = [];
        }
        prev[curr.type] = [...prev[curr.type], curr.id];
        return { ...prev };
      }, {} as IReducedMeetings),
    ),
  );
}

export function* clearReducedMeetings() {
  yield put(actions.clearReducedMeetings());
}

export function* storeCurrentMeeting(currentMeeting: IMeeting['id']) {
  yield put(currentMeeting ? actions.storeCurrentMeeting(currentMeeting) : actions.clearCurrentMeeting());
}

export function* setupMeetings(searchParams?: IMeetingSearchParams) {
  const isFetched = (yield select(meetingsPageSelectors.selectIsFetched)) as boolean;

  let meetings: IMeeting[] = [];

  if (!isFetched) {
    meetings = (yield call(meetingResourceService.searchMeetings, searchParams)) as IMeeting[];
    yield put(meetings ? actions.storeIsFetched() : actions.clearIsFetched());
  } else {
    meetings = yield select(meetingSelectors.selectResourceList);
  }
  yield call(reduceAndStoreMeetings, meetings);
}

export function* putFilteredMeetingsByUserId(userId: IUser['id']) {
  const meetings = (yield select(meetingSelectors.selectResourceList)) as IMeeting[];
  yield call(
    reduceAndStoreMeetings,
    meetings.filter((meeting) => meeting.shareWithIds.includes(userId) || meeting.administratorIds.includes(userId)),
  );
}

export function* putFilteredMeetingsByType(type: MeetingType) {
  const meetings = (yield select(meetingSelectors.selectResourceList)) as IMeeting[];
  yield call(
    reduceAndStoreMeetings,
    meetings.filter((meeting) => meeting.type === type),
  );
}

export function* putMeetings() {
  const meetings = (yield select(meetingSelectors.selectResourceList)) as IMeeting[];
  yield call(reduceAndStoreMeetings, meetings);
}
/*
export function* createMeeting(meeting: IMeetingCreateForm) {
  const agendaItemIds = (yield select(agendaItemsPageSelectors.selectAgendaItems)) as IAgendaItem['id'][];
  const agendaItems = (yield selectWithParams(agendaItemSelectors.selectResourcesById, agendaItemIds)) as IAgendaItem[];

  if (agendaItemIds.length !== meeting.agendaItems.length) {
    return;
  }

  const createdMeeting = (yield call(meetingResourceService.createMeeting, {
    ...meeting,
    repeatEvery: meeting.repeatEvery === '' ? '7' : meeting.repeatEvery,
    repeatType: meeting.repeatType.value,
    startTime: meeting.startTime.value,
    endTime: meeting.endTime.value,
    administrators: meeting.administrators.map((tupple) => tupple.value),
    shareWith: meeting.shareWith.map((tupple) => tupple.value),
    agendaItems: meeting.agendaItems.map((agendaDuration, index) => ({
      duration: agendaDuration.duration,
      sort: index,
      title: agendaDuration.title,
      agendaId: agendaItems[index].agendaId,
    })),
  })) as IMeeting;

  if (!createdMeeting) {
    return;
  }

  // const reducedMeetings = (yield select(meetingsPageSelectors.selectReducedMeetings)) as IReducedMeetings;
  // reducedMeetings[createdMeeting.type] = [...reducedMeetings[createdMeeting.type], createdMeeting.id];

  // yield put(actions.storeReducedMeetings({ ...reducedMeetings }));

  yield call(dialogService.closeDialog, 'meetingFormDialog');
}
*/
export function* createNewMeeting(meeting: IMeetingNewCreateForm) {
  const imageData = (yield select(formSelectors.selectFormAvatar)) as string;

  const createdMeeting = (yield call(meetingResourceService.createMeeting, {
    ...meeting,
    repeatEvery: meeting.repeatEvery === '' ? '7' : meeting.repeatEvery,
    repeatType: meeting.repeatType ? meeting.repeatType.value : null,
    startTime: meeting.startTime.value,
    administrators: meeting.administrators.map((tupple) => tupple.value),
    shareWith: meeting.shareWith.map((tupple) => tupple.value),
    image: imageData,
    agendaItems: meeting.agendaItems
      ? meeting.agendaItems.length > 0
        ? meeting.agendaItems.map((agendaItem, index) => ({
            duration: agendaItem.duration,
            sort: index,
            title: agendaItem.title,
            checked: agendaItem.checked,
          }))
        : []
      : [],
  })) as IMeetingResponse;

  if (!createdMeeting) {
    return;
  }

  yield call(dialogService.closeDialog, 'meetingFormDialog');
}
/*
export function* updateMeeting(id: IMeeting['id'], meeting: IMeetingCreateForm) {
  const agendaItemIds = (yield select(agendaItemsPageSelectors.selectAgendaItems)) as IAgendaItem['id'][];
  const agendaItems = (yield selectWithParams(agendaItemSelectors.selectResourcesById, agendaItemIds)) as IAgendaItem[];

  if (agendaItems.length !== meeting.agendaItems.length) {
    return;
  }

  const updatedMeeting = (yield call(meetingResourceService.updateMeeting, {
    id,
    ...meeting,
    repeatType: meeting.repeatType.value,
    startTime: meeting.startTime.value,
    endTime: meeting.endTime.value,
    administrators: meeting.administrators.map((tupple) => tupple.value),
    shareWith: meeting.shareWith.map((tupple) => tupple.value),
    agendaItems: meeting.agendaItems.map((agendaDuration, index) => ({
      duration: agendaDuration.duration,
      title: agendaDuration.title,
      sort: index,
      agendaId: agendaItems[index].agendaId,
    })),
  })) as IMeeting;

  if (!updatedMeeting) {
    return;
  }
  yield call(dialogService.closeDialog, 'meetingFormDialog');
}*/

export function* updateNewMeeting(id: IMeeting['id'], meeting: IMeetingNewCreateForm) {
  /*
  const agendaItemIds = (yield select(agendaItemsPageSelectors.selectAgendaItems)) as IAgendaItem['id'][];
  const agendaItems = (yield selectWithParams(agendaItemSelectors.selectResourcesById, agendaItemIds)) as IAgendaItem[];

  if (agendaItems.length !== meeting.agendaItems.length) {
    return;
  }
*/
  const imageData = (yield select(formSelectors.selectFormAvatar)) as string;
  const cropCounter = (yield select(formSelectors.selectCropCounter)) as number;

  //const image = imageData !== '' ? imageData : meeting.image;

  const updatedMeeting = (yield call(meetingResourceService.updateMeeting, {
    id,
    ...meeting,
    repeatType: meeting.repeatType ? meeting.repeatType.value : null,
    startTime: meeting.startTime.value,
    administrators: meeting.administrators.map((tupple) => tupple.value),
    shareWith: meeting.shareWith.map((tupple) => tupple.value),
    image: cropCounter > 1 ? imageData : meeting.image,
    agendaItems:
      meeting.agendaItems?.length > 0
        ? meeting.agendaItems.map((agendaItem, index) => ({
            duration: agendaItem.duration,
            sort: index,
            title: agendaItem.title,
            checked: agendaItem.checked,
            boardId: agendaItem.boardId ? agendaItem.boardId : '',
            boardListId: agendaItem.boardListId ? agendaItem.boardListId : '',
            embedUrl: agendaItem.embedUrl ? agendaItem.embedUrl : '',
          }))
        : [],
  })) as IMeeting;

  if (!updatedMeeting) {
    return;
  }
  yield call(storeAgendaItems, updatedMeeting.agendaItemIds);

  yield call(dialogService.closeDialog, 'meetingFormDialog');
  yield call(dialogService.closeDialog, 'agendaFormDialog');
  yield call(dialogService.closeDialog, 'agendaCustomFormDialog');
  yield put(saveFormAvatar(''));
  yield put(saveCropCounter(0));
}

export function* deleteMeeting(meetingId: IMeeting['id']) {
  yield call(meetingResourceService.deleteMeeting, meetingId);
}

export function* startMeetingSession(meetingId: IMeeting['id'], userId: IUser['id'], sessionId: ISession['id']) {
  yield call(meetingResourceService.startMeetingSession, meetingId, userId, sessionId);
}

export function* finishMeetingSession(meetingId: IMeeting['id']) {
  const meetingSimple = yield select(meetingSimpleSelectors.selectResourceById, meetingId);
  yield put(agendaItemsAction.clearCurrentAgenda());

  const { sessions } = (yield call(apiRequest, scoreApi.getScoreBoardApi({ meetingId }))) as {
    scores: IScore[];
    sessions: ISession[];
    scoreboards: {
      [sessionId: string]: IKpiRowScoreboard[];
    };
  };
  const sessionsIds = sessions.map((session) => session.id);
  yield put(storeSessionIds(sessionsIds));
  yield put(push(`/meeting-dashboard/${meetingId}/${slugify(meetingSimple.title, { delimiter: '-' })}`));
}

export function* joinMeeting(meetingId: IMeeting['id'], userId: IUser['id'], sessionId: ISession['id']) {
  yield call(meetingResourceService.joinMeeting, meetingId, userId, sessionId);
}

export function* handleJoinMeeting(meetingId: IMeeting['id'], userId: IUser['id'], sessionId: ISession['id']) {
  const session = (yield selectWithParams(sessionSelectors.selectResourceById, sessionId)) as ISession;
  const newMeetingMembers = Array.from(new Set([...session.meetingMembers, userId]));
  const updatedSession = { ...session, meetingMembers: newMeetingMembers };
  yield call(sessionResourceService.storeSession, updatedSession);
}

export function* handleMeetingFromNotification(meetingResponse: IMeetingResponse) {
  // const meeting = meetingResourceService.meetingResponseToMeeting(meetingResponse);
  // const meetingExists = (yield selectWithParams(meetingSelectors.selectResourceById, meeting.id)) as IMeeting | null;
  // yield call(meetingResourceService.storeMeeting, {
  //   ...meeting,
  //   taskIds: meetingExists ? meetingExists.taskIds : null,
  //   sessionIds: meetingExists ? meetingExists.sessionIds : null,
  //   kpiId: meetingExists ? meetingExists.kpiId : null,
  // });
  // if (meetingExists) {
  //   return;
  // }
  // const reducedMeetings = (yield select(meetingsPageSelectors.selectReducedMeetings)) as IReducedMeetings;
  // let newReducedMeetings: IReducedMeetings = {};
  // if (reducedMeetings) {
  //   newReducedMeetings = { ...reducedMeetings };
  // }
  // if (!newReducedMeetings[meeting.type]) {
  //   newReducedMeetings[meeting.type] = [];
  // }
  // newReducedMeetings[meeting.type] = [...newReducedMeetings[meeting.type], meeting.id];
  // yield put(actions.storeReducedMeetings(newReducedMeetings));
}

// apparently this function is useless
export function* handleStartMeetingSession(meeting: IMeetingResponse) {
  const startedMeetings = (yield select(meetingsPageSelectors.selectStartedMeetings)) as IMeeting['id'][];
  if (startedMeetings.includes(meeting.id)) {
    return;
  }
  const newStartedMeetings = [...startedMeetings, meeting.id];
  yield put(actions.storeStartedMeetings(newStartedMeetings));
}

export function* clearMeetingsPageStorage() {
  yield put(actions.clearReducedMeetings());
  yield put(actions.clearIsFetched());
}
